import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const ContactUs = () => {
  return (
    <div className="pp-page">
      <div className="pp-wrapper">
        {/* Header */}
        <div className="pp-header-section">
          <h1 className="pp-main-title">Contact Us</h1>
        </div>

        {/* Introduction */}
        <section className="pp-content-section">
          <p className="pp-intro-text">
            We'd love to hear from you! Whether you have a question about our
            products, need help with an order, or just want to say hello — our
            team is here to help.
          </p>
        </section>

        {/* Get in Touch */}
        <section className="pp-content-section pp-contact-box">
          <h2 className="pp-section-title">Get in Touch</h2>
          <div className="pp-contact-grid">
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Email</strong>
              <a href="mailto:kittynmice00@gmail.com" className="pp-link">
                kittynmice00@gmail.com
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Phone</strong>
              <a href="tel:+918076217714" className="pp-link">
                +91 80762 17714
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">WhatsApp</strong>
              <a
                href="https://wa.me/918076217714"
                className="pp-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 80762 17714
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Instagram</strong>
              <a
                href="https://www.instagram.com/kittynmice"
                className="pp-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                @kittynmice
              </a>
            </div>
          </div>
        </section>

        {/* Our Address */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">Our Address</h2>
          <p className="pp-text pp-address">
            Kitty n Mice
            <br />
            Vikaspuri, New Delhi 110018
            <br />
            India
          </p>
        </section>

        {/* Business Hours */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">Business Hours</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              <strong className="pp-bold">Monday - Saturday:</strong> 10:00 AM -
              7:00 PM
            </li>
            <li className="pp-list-item">
              <strong className="pp-bold">Sunday:</strong> Closed
            </li>
          </ul>
        </section>

        {/* How We Can Help */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">How We Can Help</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Order related queries (tracking, cancellation, modifications)
            </li>
            <li className="pp-list-item">
              Product enquiries (sizes, availability, fabric details)
            </li>
            <li className="pp-list-item">Returns and exchange assistance</li>
            <li className="pp-list-item">
              Bulk or wholesale enquiries
            </li>
            <li className="pp-list-item">
              Feedback and suggestions
            </li>
          </ul>
          <p className="pp-text">
            We try our best to respond within 24 hours on working days. For
            faster assistance, reach out to us on WhatsApp!
          </p>
        </section>

        {/* Footer Links */}
        <div className="pp-footer-section">
          <p className="pp-footer-text">Helpful Links:</p>
          <div className="pp-footer-links">
            <Link to="/shipping-policy" className="pp-footer-link">
              Shipping Policy
            </Link>
            <Link to="/refund-policy" className="pp-footer-link">
              Return Policy
            </Link>
            <Link to="/privacy" className="pp-footer-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
